import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import PropTypes from 'prop-types';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { allTemasAcademicosAction } from '../TemasAcademicosAction';

const SelectFieldTemasAcademicosComponent = ({
  onChange,
  id,
  data,
  isEmpty = true,
  value,
  required = false,
  error = false,
  selects = [],
}) => {
  const dispatch = Redux.useDispatch();

  const temasAcademicosStore = Redux.useSelector(
    (state) => state.temasAcademicos,
  );

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && temasAcademicosStore.all.length === 0) {
        await allTemasAcademicosAction(dispatch, null);
        setItems(temasAcademicosStore.all);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      temasAcademicosStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setItems(items);
    } else {
      if (data) {
        setItems(data);
      } else {
        setItems(temasAcademicosStore.all);
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  return (
    <FormControl fullWidth size="small" required={required} error={error}>
      <InputLabel id={`label_${id}`}>{CONST.temasAcademicos.label}</InputLabel>
      <Select
        id={CONST.ID}
        value={value}
        labelId={`label_${id}`}
        label={CONST.temasAcademicos.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {isEmpty && (
          <MenuItem key={`${id}-000-item`} value={null}>
            NINGUNO
          </MenuItem>
        )}
        {items.map((el, index) => {
          return (
            <MenuItem key={`item_${id}_${index}`} value={el.id}>
              {el.titulo}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

SelectFieldTemasAcademicosComponent.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SelectFieldTemasAcademicosComponent;
